
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.322 4.731l3.131 3.515C8.7 4.882 12.343 1.934 15.646.234c.74-.454 1.88-.19 1.082.302-3.701 2.532-6.548 5.404-9.452 9.902-1.14.529-2.449.793-3.075.302L.1 5.865C-.47 5.26 1.524 3.862 2.32 4.73z","fill":"#FDF8F8"}})])
          )
        }
      }
    